module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_1_Active@1x-149e9632746760c95ea7a831ae38de00.png";